import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"filter\"><path d=\"M0 15.27h2.18v6.55h2.18v-6.55h2.18v-2.18H0v2.18zM19.64 2.18h2.18V12h-2.18zM2.18 2.18h2.18v7.64H2.18zM17.45 15.27v2.18h2.19v4.37h2.18v-4.37H24v-2.18h-6.55zM13.09 2.18h-2.18v4.36H8.73v2.19h6.54V6.54h-2.18V2.18zM10.91 12h2.18v9.82h-2.18z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol